<template>
  <form action="/download-document" class="tenant-form" :name="formId" :id="formId" method="post" target="_blank">
    <input name="_token" type="hidden" :value="token">
    <input name="propertyId" type="hidden" :value="property">
    <input name="landlordId" type="hidden" :value="landlord">
    <input name="subscriptionId" type="hidden" :value="subscription">
    <input name="documentId" type="hidden" :value="document">
    <div class="tenant-form__row" v-if="allowSigned">
      <strong class="tenant-form__subtitle">{{selectSignedCheckbox}}</strong>
    </div>
    <div
      class="tenant-form__row"
      v-for="(tenantBlock, tenantIndex) in tenantInfo"
      v-if="allowSigned"
    >
      <div
        class="tenant-form__row"
        v-for="(checkboxSigned, checkboxIndex) in tenantBlock.signedCheckboxList"
      >
        <input
          class="tenant-form__checkbox"
          type="checkbox"
          :name="'fileId[]'"
          :value="checkboxSigned.id"
          :id="formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex + '-signed'"
          :disabled="checkboxSigned.disabled"
          :checked="checkboxSigned.value"
          @change="checkboxSigned.value = !checkboxSigned.value"
        >
        <span
          class="tenant-form__label-inner"
          v-if="!checkboxSigned.disabled && checkboxSigned.filename && checkboxSigned.filename.slice(-3).toLowerCase()==='pdf'"
        >
          <a
            :title="checkboxSigned.imageName"
            :href="checkboxSigned.imageUrl"
            class="tenant-form__gallery-link"
            :data-rel="'lightcase:myCollection' + formId"
          >{{checkboxSigned.checkboxText}}</a>
        </span>
        <span class="tenant-form__label-inner" v-else-if="!checkboxSigned.disabled">
          <a
            :title="checkboxSigned.imageName"
            :href="'#box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex + '-signed'"
            class="tenant-form__gallery-link"
            :data-rel="'lightcase:myCollection' + formId"
          >{{checkboxSigned.checkboxText}}</a>
        </span>
        <span class="tenant-form__label-inner" v-else>
          <span class="tenant-form__checkbox-info">
            {{checkboxSigned.checkboxText}}
            <div>
              {{checkboxSigned.reason}}
              <i class="far fa-eye" @click.self="showTenantTooltip">
                <span class="tenant-form__tooltip">
                  <div class="tenant-form__tooltip-overlay" @click="closeTenantTooltip"></div>
                  <div class="tenant-form__tooltip-box">
                    <div class="tenant-form__tooltip-close-icon" @click="closeTenantTooltip"></div>
                    <div class="tenant-form__tooltip-text">{{checkboxSigned.reasonFullText}}</div>
                  </div>
                </span>
              </i>
            </div>
          </span>
        </span>
        <v-lightcase-holder
          :image-src="checkboxSigned.imageUrl"
          :name="'box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex + '-signed'"
          :current-document="checkboxSigned"
          :disable-rotate="true"
        ></v-lightcase-holder>
      </div>
    </div>
    <div class="tenant-form__row">
      <template v-if="allowSigned">
        <br>
        <br>
      </template>
      <label :for="selectAllId" class="tenant-form__label" @change="setStateToAllCheckboxes">
        <input class="tenant-form__checkbox" type="checkbox" :name="selectAllId" :id="selectAllId">
        <span class="tenant-form__label-inner">{{selectAllCheckbox}}</span>
      </label>
    </div>
    <div class="tenant-form__row" v-for="(tenantBlock, tenantIndex) in tenantInfo">
      <strong class="tenant-form__subtitle">{{tenantBlock.text}}</strong>
      <div class="tenant-form__row" style="margin-bottom:15px;" v-if="tenantBlock.showExtraInformation && tenantBlock.extraInformations && tenantBlock.extraInformations!=''">
        <span><strong>{{locales && locales.common && locales.common.extra_informations}}</strong></span>
        <div><em v-html="tenantBlock.extraInformations"></em></div>
      </div>
      <div class="tenant-form__row" v-for="(checkbox, checkboxIndex) in tenantBlock.checkboxList">
        <input
          class="tenant-form__checkbox"
          type="checkbox"
          :name="'fileId[]'"
          :value="checkbox.id"
          :id="formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex"
          :disabled="checkbox.disabled"
          :checked="checkbox.value"
          @change="checkbox.value = !checkbox.value"
        >
        <span
          class="tenant-form__label-inner"
          v-if="!checkbox.disabled && checkbox.filename && checkbox.filename.slice(-3).toLowerCase()==='pdf'"
        >
          <a
            :title="checkbox.imageName"
            :href="checkbox.imageUrl"
            class="tenant-form__gallery-link"
            :data-rel="'lightcase:myCollection' + formId"
          >{{checkbox.checkboxText}}</a>
        </span>
        <span class="tenant-form__label-inner" v-else-if="!checkbox.disabled">
          <a
            :title="checkbox.imageName"
            :href="'#box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex"
            class="tenant-form__gallery-link"
            :data-rel="'lightcase:myCollection' + formId"
          >{{checkbox.checkboxText}}</a>
        </span>
        <span class="tenant-form__label-inner" v-else>
          <span class="tenant-form__checkbox-info">
            {{checkbox.checkboxText}}
            <div>
              {{checkbox.reason}}
              <i class="far fa-eye" @click.self="showTenantTooltip">
                <span class="tenant-form__tooltip">
                  <div class="tenant-form__tooltip-overlay" @click="closeTenantTooltip"></div>
                  <div class="tenant-form__tooltip-box">
                    <div class="tenant-form__tooltip-close-icon" @click="closeTenantTooltip"></div>
                    <div class="tenant-form__tooltip-text">{{checkbox.reasonFullText}}</div>
                  </div>
                </span>
              </i>
            </div>
          </span>
        </span>
        <v-lightcase-holder
          :image-src="checkbox.imageUrl"
          :name="'box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex"
          :current-document="checkbox"
          :disable-rotate="true"
        ></v-lightcase-holder>
      </div>
    </div>
    <div class="tenant-form__footer">
        {{downloadText}} :
      <input
        class="tenant-form__submit"
        type="submit"
        name="type"
        value="PDF"
        title="Save as pdf"
        :disabled="!isSomeCheckboxChecked"
      >
      <input
        class="tenant-form__submit"
        type="submit"
        name="type"
        value="ZIP"
        title="Save as zip"
        :disabled="!isSomeCheckboxChecked"
      >
      <input
        class="tenant-form__submit"
        type="submit"
        name="type"
        value="PRINT"
        title="Print"
        @click.prevent="print"
        :disabled="!isSomeCheckboxChecked"
      >
    </div>
  </form>
</template>
<script>
import MobileDetect from "mobile-detect/mobile-detect";
import "lightcase/src/css/lightcase.css";
import configurePublicLightcase from "../../public-lightcase.js";
import VLightcaseHolder from "./VLightcaseHolder";
import { mapGetters } from "vuex";

window.MobileDetect = MobileDetect;

export default {
  components: {
    VLightcaseHolder
  },
  data() {
    return {
      allCheckboxesState: false
    };
  },
  computed: {
    ...mapGetters(["locales"]),
    formId: function() {
      return "tenant-form-" + this.id;
    },
    selectAllId: function() {
      return "select-all-" + this.id;
    },
    isSomeCheckboxChecked: function() {
      var info = null;
      for (var i = 0; i < this.tenantInfo.length; i++) {
        info = this.tenantInfo[i];
        for (var y = 0; y < info.checkboxList.length; y++) {
          if (!info.checkboxList[y].disabled) {
            if (info.checkboxList[y].value === true) return true;
          }
        }
        if (info.signedCheckboxList !== undefined) {
          for (var y = 0; y < info.signedCheckboxList.length; y++) {
            if (!info.signedCheckboxList[y].disabled) {
              if (info.signedCheckboxList[y].value === true) return true;
            }
          }
        }
      }
      return false;
    }
  },
  props: {
    id: {
      default: "",
      type: Number
    },
    subscription: {
      default: "",
      type: String
    },
    property: {
      default: "",
      type: String
    },
    landlord: {
      default: "",
      type: String
    },
    document: {
      default: "",
      type: String
    },
    allowSigned: {
      default: 0,
      type: Number
    },
    selectAllCheckbox: {
      default: "",
      type: String
    },
    selectSignedCheckbox: {
      default: "",
      type: String
    },
    tenantInfo: {
      default: () => [],
      type: Array
    },
    downloadText: {
      default: "",
      type: String
    },
    token: {
      default: "",
      type: String
    }
  },
  methods: {
    showTenantTooltip: function(event) {
      this.closeTenantTooltip();
      event.target
        .querySelector(".tenant-form__tooltip")
        .classList.add("tenant-form__tooltip_active");
    },
    closeTenantTooltip: function() {
      $(".tenant-form__tooltip_active").removeClass(
        "tenant-form__tooltip_active"
      );
    },
    setStateToAllCheckboxes: function() {
      var info = null;
      if (!this.allCheckboxesState) {
        for (var i = 0; i < this.tenantInfo.length; i++) {
          info = this.tenantInfo[i];
          for (var y = 0; y < info.checkboxList.length; y++) {
            if (!info.checkboxList[y].disabled)
              info.checkboxList[y].value = true;
          }
        }
        this.allCheckboxesState = true;
      } else {
        for (var i = 0; i < this.tenantInfo.length; i++) {
          info = this.tenantInfo[i];
          for (var y = 0; y < info.checkboxList.length; y++) {
            info.checkboxList[y].value = false;
          }
        }
        this.allCheckboxesState = false;
      }
    },
    print: function(e){               
            let form = $('.tenant-form').first();
            let data = form.serialize();
            data = data + "&type=PRINT";
            $.ajax({
                url: form.attr('action'),
                method: 'post',
                data: data,
                success: function (result) {
                  var w = window.open(result);
                  if (navigator.appName == 'Microsoft Internet Explorer') window.print();
                  else w.print();
                }
            });
         },
  },
  beforeMount() {
    configurePublicLightcase();
  },
  beforeUpdate() {
    configurePublicLightcase();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VTenantForm.vue